<template>
    <div class="rzy-page home">
        <el-row :gutter="10" style="height:100%">
            <!--左侧-->
            <el-col :span="24">
                <div class="home-top-list home-block">
                    <div>{{ factoryName }}</div>
                    <div>{{ serverTime }}</div>
                </div>
            </el-col>
            <el-col span="16" style="height:100%;">
                <div style="height:100%">
                    <div class="home-top-list home-block">
                        <div class="home-top-item" v-for="t in tops" :key="t.key">
                            <div class="home-top-title">{{ t.name }}</div>
                            <div class="home-top-value" :style="{ color: t.color }">
                                {{ t.volue }}
                            </div>
                        </div>
                    </div>

                    <div style="margin-top:15px;">
                        <el-row :gutter="10">
                            <el-col span="14">
                                <div class="home-block nopad">
                                    <div class="home-table-title">本月胚布生产排名</div>
                                    <table class="home-table">
                                        <thead>
                                            <tr>
                                                <th style="width:10%"></th>
                                                <th>品类</th>
                                                <th>产量</th>
                                                <th>占比</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="home-table-row" v-for="(pb, idx) in peibus" :key="pb.key">
                                                <td>{{ idx + 1 }}</td>
                                                <td class="home-table-cell">{{ pb.name }}</td>
                                                <td class="home-table-cell">{{ pb.volue }}</td>
                                                <td class="home-table-cell">{{ pb.percent }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </el-col>
                            <el-col span="10">
                                <div class="home-block nopad">
                                    <div class="home-table-title">本月机台产能效率排名</div>
                                    <table class="home-table">
                                        <thead>
                                            <tr>
                                                <th style="width:10%"></th>
                                                <th>机台</th>
                                                <th>产能</th>
                                                <th>开机率</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="home-table-row" v-for="(m, idx) in machines" :key="m.key">
                                                <td>{{ idx + 1 }}</td>
                                                <td class="home-table-cell">{{ m.name }}</td>
                                                <td class="home-table-cell">{{ m.volue }}</td>
                                                <td class="home-table-cell">{{ m.percent }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="home-block" style="margin-top:15px;min-height:300px;">
                        <div style="">产能趋势图</div>
                        <div ref="bar1" chartID="bar1" :option="monthSummaryChart" width="100%" height="100%"
                            style="min-height:300px;height:300px;"></div>
                    </div>

                    <div class="home-status-list home-block" style="margin-top:15px;">
                        <div class="home-status-item" v-for="s in statuses" :key="s.key" :style="{ color: s.color }">
                            <span class="home-top-title">{{ s.name }}：</span>
                            <span class="home-top-value">{{ dummy == 1 ? s.volue * 2 : s.volue }}人</span>
                        </div>
                    </div>
                </div>
            </el-col>

            <!--右侧-->
            <el-col span="8">
                <div class="home-block">
                    <div class="home-block-title">实时机台状态</div>
                    <el-divider></el-divider>

                    <!--分隔符 -->
                    <div class="home-summary-grid">
                        <div class="home-summary-item">
                            <div class="home-summary-title">{{ ms0.name }}</div>
                            <div class="home-summary-value" :style="{ color: ms0.color }">
                                {{ dummy == 1 ? stateTabList[1].content : ms0.volue }}
                            </div>
                        </div>
                        <div class="home-summary-item">
                            <div class="home-summary-title">{{ ms1.name }}</div>
                            <div class="home-summary-value" :style="{ color: ms1.color }">
                                {{ dummy == 1 ? stateTabList[2].content : ms1.volue }}
                            </div>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <div class="home-summary-grid">
                        <div class="home-summary-item">
                            <div class="home-summary-title">{{ ms2.name }}</div>
                            <div class="home-summary-value" :style="{ color: ms2.color }">
                                {{ dummy == 1 ? stateTabList[3].content : ms2.volue }}
                            </div>
                        </div>
                        <div class="home-summary-item">
                            <div class="home-summary-title">{{ ms3.name }}</div>
                            <div class="home-summary-value" :style="{ color: ms3.color }">
                                {{ dummy == 1 ? stateTabList[4].content : ms3.volue }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="home-order-list home-block" style="margin-top: 15px;overflow:auto; height: 244px;">
                    <div class="home-block-title">实时工单状态</div>
                    <div class="home-order-item" v-for="ws in workOrderStatus" :key="ws.key">
                        <div style="width: 40px;">#{{ ws.number }}</div>
                        <el-progress class="order-progress" :text-inside="true" :stroke-width="16"
                            :percentage="ws.volue" :color="progressColors"></el-progress>
                    </div>
                </div>

                <div class="home-work-list home-block" style=" margin-top: 15px;">
                    <div class="home-block-title">实时报工记录</div>
                    <div class="home-work-event" v-for="e in workEvents" :key="e.key">
                        <span>{{ e.time }}</span>
                        <span> {{ e.machine }}#机</span>
                        <span> - {{ e.worker }}</span>
                        <span> - {{ e.event }}</span>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import * as api from "@/api/factory/machine/preview";
    import tabConfig from "./machineTabConfig.js";
    import {
        mapState,
        mapActions
    } from "vuex";

    const MAX_RANK_ITEM = 6;
    const MAX_MONTH = 12; //最大显示12个月

    export default {
        data() {
            return {
                dummy: null,
                stateTabList: [],
                factoryName: "",
                serverTime: "",
                progressColors: [{
                        color: "#f56c6c",
                        percentage: 20,
                    },
                    {
                        color: "#e6a23c",
                        percentage: 40,
                    },
                    {
                        color: "#6f7ad3",
                        percentage: 60,
                    },
                    {
                        color: "#1989fa",
                        percentage: 80,
                    },
                    {
                        color: "#5cb87a",
                        percentage: 100,
                    },
                ],
                //左上统计
                tops: [{
                        key: "t1",
                        name: "今日产能",
                        volue: "0KG",
                        color: "#00ff00",
                    },
                    {
                        key: "t2",
                        name: "今日开机率",
                        volue: "0%",
                        color: "#00ffff",
                    },
                    {
                        key: "t3",
                        name: "今日停机数",
                        volue: "0次",
                        color: "#0000ff",
                    },
                    {
                        key: "t4",
                        name: "今日瑕点数",
                        volue: "0个",
                        color: "#ff00ff",
                    },
                ],
                //左下上工状态
                statuses: [{
                        key: "s1",
                        name: "总上工",
                        volue: "0",
                        color: "#fff",
                    },
                    {
                        key: "s2",
                        name: "挡车工",
                        volue: "0",
                        color: "#00ff00",
                    },
                    {
                        key: "s3",
                        name: "机修工",
                        volue: "0",
                        color: "#ff0000",
                    },
                    {
                        key: "s4",
                        name: "盘头工",
                        volue: "0",
                        color: "#00ffff",
                    },
                    {
                        key: "s5",
                        name: "穿纱工",
                        volue: "0",
                        color: "#ff00ff",
                    },
                ],
                //右上机台统计
                machineSummary: [{
                        key: "ms1",
                        name: "运行",
                        volue: "0",
                        color: "greenyellow",
                    },
                    {
                        key: "ms2",
                        name: "暂停",
                        volue: "0",
                        color: "yellow",
                    },
                    {
                        key: "ms3",
                        name: "故障",
                        volue: "0",
                        color: "red",
                    },
                    {
                        key: "ms4",
                        name: "离线",
                        volue: "0",
                        color: "darkgray",
                    },
                ],
                //右中工单状态
                workOrderStatus: [
                    // {
                    //     key: 'wo1',
                    //     number: '1',
                    //     volue: '15',
                    // },
                    // {
                    //     key: 'wo2',
                    //     number: '2',
                    //     volue: '70',
                    // },
                    // {
                    //     key: 'wo3',
                    //     number: '3',
                    //     volue: '80',
                    // },
                    // {
                    //     key: 'wo4',
                    //     number: '4',
                    //     volue: '100',
                    // },
                    // {
                    //     key: 'wo5',
                    //     number: '5',
                    //     volue: '50',
                    // },
                ],
                //胚布排名
                peibus: [{
                        key: "pb1",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "pb2",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "pb3",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "pb4",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "pb5",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "pb6",
                        name: "",
                        value: "",
                        percent: "",
                    },
                ],
                //开机效率排名
                machines: [{
                        key: "m1",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "m2",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "m3",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "m4",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "m5",
                        name: "",
                        value: "",
                        percent: "",
                    },
                    {
                        key: "m6",
                        name: "",
                        value: "",
                        percent: "",
                    },
                ],
                //报工记录
                workEvents: [
                    // {
                    //                    key: 'e1',
                    //                    worker: '赵云',
                    //                    machine: '1',
                    //                    event: '结束维修',
                    //                    time: '2022/01/04 15:30:00'
                    //                },
                    //                {
                    //                    key: 'e2',
                    //                    worker: '赵云',
                    //                    machine: '1',
                    //                    event: '开始维修',
                    //                    time: '2022/01/04 15:00:00'
                    //                },
                ],
                //产能趋势图--sta
                // 指定图表的配置项和数据
                monthSummaryChart: {
                    dataset: {
                        source: [
                            ["1月", 1, 30],
                            ["2月", 2, 40],
                            ["3月", 3, 50],
                            ["4月", 4, 10],
                            ["5月", 5, 20],
                            ["6月", 6, 30],
                            ["7月", 7, 50],
                            ["8月", 8, 30],
                            ["9月", 9, 50],
                            ["10月", 10, 60],
                            ["11月", 11, 70],
                            ["12月", 12, 30],
                        ],
                    },
                    xAxis: {
                        // 数组每项表示一个组件实例，用 type 描述“子类型”。
                        type: "category",
                        //设置坐标轴字体颜色和宽度
                        axisLine: {
                            lineStyle: {
                                color: "#fff",
                            },
                        },
                    },
                    yAxis: [{
                            //设置坐标轴字体颜色和宽度
                            name: "产能(KG)",
                            axisLine: {
                                lineStyle: {
                                    color: "#fff",
                                },
                            },
                        },
                        {
                            name: "开机率",
                            //设置坐标轴字体颜色和宽度
                            axisLine: {
                                lineStyle: {
                                    color: "#fff",
                                },
                            },
                            //右侧刻度的网格线
                            splitLine: {
                                show: false, //不显示
                            },
                            min: 0,
                            max: 100,
                            position: "right",
                            axisLabel: {
                                formatter: "{value}%",
                            },
                        },
                    ],
                    series: [
                        // 数据从 dataset 中取，encode 中的数值是 dataset.source 的维度 index （即第几列）
                        {
                            type: "bar",
                            yAxisIndex: 0,
                            encode: {
                                x: 0,
                                y: 1,
                            },
                            itemStyle: {
                                color: "#ff0",
                            },
                        },
                        {
                            type: "line",
                            yAxisIndex: 1,
                            encode: {
                                x: 0,
                                y: 2,
                            },
                            lineStyle: {
                                color: "#0f0",
                            },
                        },
                    ],
                    tooltip: {
                        show: true,
                        formatter: (p) => {
                            return (
                                p.data[0] +
                                "<br>产能：" +
                                p.data[1] +
                                "千米<br>开机率：" +
                                p.data[2] +
                                "%"
                            );
                        },
                    },
                },
                //产能趋势图--end
                //echart line
                bar1: null,
                roleData: [],
            };
        },
        computed: {
            ms0() {
                return this.machineSummary[0];
            },
            ms1() {
                return this.machineSummary[1];
            },
            ms2() {
                return this.machineSummary[2];
            },
            ms3() {
                return this.machineSummary[3];
            },
        },
        created() {
            this.getList();
            this.getRoleData();
        },
        methods: {
            ...mapActions("role", ["updateRole"]),
            getRoleData() {
                api.getRoleData().then((res) => {
                    console.log(res);
                    this.roleData = res.data.privileges.privileges;
                    console.log(this.roleData);
                    const roleList = [];
                    this.roleData.forEach((item) => {
                        console.log(item);
                        roleList.push(item.privilegeName);
                    });
                    console.log(roleList);
                    this.updateRole(roleList);
                    // window.localStorage.setItem("role", JSON.stringify(roleList));
                });
            },
            getList() {
                return api.getList({
                    kind: ""
                }).then((res) => {
                    console.log(res);
                    this.dummy = res.data.dummy;
                    console.log(this.dummy);

                    //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--sta
                    // this.stateTabList = this.countStateTab(this.initResponse(res.data))
                    this.stateTabList = this.countStateTab(
                        this.initResponse(res.data.machineState, res.data.serverTime)
                    );
                    console.log(this.stateTabList);
                    //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--end
                });
            },
            // 格式化返回数据
            initResponse(res, serverTime) {
                console.log(res);
                var arr = [];
                if (this.dummy == 1) {
                    var list1 = res;
                    var list2 = this.utils.deepClone(list1);
                    var list3 = this.utils.deepClone(list1);
                    var list4 = list3.slice(0, 2);
                    console.log(list1, list2, list4);
                    if (this.value1 == 1) {
                        var currentMachineNumber = list1.length + 1;

                        // 更新 arr2 的 machineNumber
                        list2.forEach(function(item) {
                            item.machineNumber = ("整" + currentMachineNumber++).toString();
                        });
                    } else {
                        var currentMachineNumber = list1.length + 5;

                        // 更新 arr2 的 machineNumber
                        list2.forEach(function(item) {
                            item.machineNumber = (currentMachineNumber++).toString();
                        });
                        var arr1 = list1.concat(list2);
                        console.log(arr1);
                        var currentMachineNumber1 = arr1.length + 5;
                        list4.forEach(function(item) {
                            item.machineNumber = (currentMachineNumber1++).toString();
                        });
                    }

                    if (this.value1 == 1) {
                        arr = list1.concat(list2);
                    } else {
                        arr = arr1.concat(list4);
                    }
                    // arr = arr1.concat(list4);
                    console.log(arr);
                } else if (this.dummy == 0) {
                    arr = res;
                }

                // 依照机台编号进行排序  liuqy  微信方式搬过来
                var response = this._.sortBy(arr, (obj) => {
                    // console.log(obj);
                    // 默认升序 降序return的结果加 - ，-obj.machine.number
                    // 提取字母 obj.machineNumber.replace(/[^a-z]+/ig,"");
                    var machineNumber = obj.machineNumber.replace(/[^0-9]+/gi, "");
                    return Number(machineNumber);
                });
                response = this.judgeOffline(response, serverTime);
                // response.forEach((item, index) => {

                // });
                return response;
            },
            judgeOffline(response, serverTime) {
                //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--sta
                // const now = new Date().getTime()
                const now = serverTime;
                //230220 hcy: 返回结构发生变化，其中serverTime是服务器时间(ms)，machineState是原先的结构数据.--end
                response.forEach((obj) => {
                    const dValue = now - obj.unixTime;
                    if (dValue > 60000) {
                        obj.machineWorkingState = -1;
                    }
                });
                return response;
            },
            countStateTab(response) {
                const stateTabGroup = this._.groupBy(response, (item) => {
                    // 先赋值默认的状态，以防可能出现找不到的情况
                    var tabIndex = tabConfig.tabDefault;
                    const arr = this.$enum.stateTab;
                    const state = Number(item.machineWorkingState);
                    try {
                        arr.forEach((stateArr, index) => {
                            if (this._.indexOf(stateArr, state) !== -1) {
                                tabIndex = index + 1;
                                // 如果已经找到状态，那么抛异常结束循环
                                throw new Error("stop forEach");
                            }
                        });
                    } catch (e) {
                        if (e.message !== "stop forEach") throw e;
                    }
                    return tabIndex;
                });
                stateTabGroup[tabConfig.allIndex] = response;
                console.log(stateTabGroup);
                this.stateTabCache = stateTabGroup;
                const formatArr = [];
                // 按d-point-tab要求的数据格式进行拼接
                tabConfig.tabInfo.forEach((obj, index) => {
                    formatArr.push({
                        title: obj.name,
                        content: stateTabGroup[index] ?
                            `${stateTabGroup[index].length}` :
                            "0",
                        // type: obj.type,
                    });
                });
                console.log(formatArr);
                return formatArr;
            },

            // 获取后台数据
            getData() {
                this.$requestBase({
                    url: "v1/home/dashboard",
                    method: "get",
                }).then((res) => {
                    // this.dummy = res.data.dummy;
                    // console.log(this.dummy);
                    this.formatResponse(res.data);
                });
            },

            // 格式化数据
            formatResponse(response) {
                this.factoryName = response.factoryName;
                this.serverTime = this.utils.timestampToTime(response.serverTime * 1000);
                //左------------------------------------------------
                //今日产能
                //hcy: productMeter 是厘米数，要 /100000，保留 2位小数.=>
                // 251030 hcy: 我已经加了productWeight参数，重量，单位g。
                this.$set(
                    this.tops[0],
                    "volue",
                    String(
                        (response.machineDailySummary.productWeight / 1000).toFixed(2)
                    ) + "KG"
                ); //今日产能

                //开机率 = 总开机时间runningTime / 总机台数 * 24小时 * 3600秒
                this.$set(
                    this.tops[1],
                    "volue",
                    this.realtimeRunningEffect(
                        response.machineDailySummary.runningTime,
                        response.machineSummary.totalCount,
                        response.sendTime   //后台传来的时间戳 = 当前时间(毫秒)
                    )
                );

                this.$set(
                    this.tops[2],
                    "volue",
                    String(response.machineDailySummary.haltCount) + "次"
                ); //停机数
                this.$set(
                    this.tops[3],
                    "volue",
                    String(response.machineDailySummary.defectCount) + "个"
                ); //瑕点数

                // 本月胚布生产排名
                //限制 最多显示 6条记录 ?
                let i = 0;
                let peibus0 = [];
                let pbs = response.peibuRank;
                let pblen = pbs.length < MAX_RANK_ITEM ? pbs.length : MAX_RANK_ITEM;
                // console.log(pbs)
                for (; i < pblen; i++) {
                    let pb = pbs[i];
                    // console.log(pb)
                    let item = {
                        key: "pb" + (i + 1),
                        name: String(pb.productName),
                        //hcy: productLength 是厘米，要 /100000，保留 2位小数.=>
                        // 251030 hcy: 我已经加了productWeight参数，重量，单位g。
                        volue: String((pb.productWeight / 1000).toFixed(2)) + "KG",
                        percent: pb.percent != null ? pb.percent + "%" : "0%",
                    };
                    peibus0.push(item);
                }
                //补足剩余部分
                for (; i < MAX_RANK_ITEM; i++) {
                    let item = {
                        key: "pb" + (i + 1),
                        name: "",
                        volue: "",
                        percent: "",
                    };
                    peibus0.push(item);
                }
                this.peibus = peibus0;

                //本月机台产能效率排名
                //hcy: 前端限制下只显示前6条数据?
                // 251022 -sta
/*
                用后台送来的当前时间戳 sendtime 转换成 实际统计天数。
                例如：sendtime = 1761134415957, 表示 【2025-10-22 20:00:15】,【开机率统计报表】只算到昨天(21日)数据,
                所以实际统计天数 = 21天。
*/
                let l_totalDay = this.utils.getYesterdayDate(response.sendTime);
                console.log("l_totalDay=",l_totalDay);
                // 251022 -end
                let machines0 = [];
                for (
                    i = 0; i <
                    (response.machineRank.length < MAX_RANK_ITEM ?
                        response.machineRank.length :
                        MAX_RANK_ITEM); i++
                ) {
                    let item = {
                        key: "m" + (i + 1),
                        //机台
                        name: String(response.machineRank[i].machineNumber) + "#",
                        //产能
                        //hcy: productLength 是厘米，要 /100000，保留 2位小数.=>
                        // 251030 hcy: 我已经加了productWeight参数，重量，单位g。
                        volue: String(
                            (response.machineRank[i].productWeight / 1000).toFixed(2)
                        ) + "KG",
                        //开机率
                        percent: String(
                            (
                                (response.machineRank[i].runningTime / (l_totalDay * 86400)) *
                                100
                            ).toFixed(0)
                        ) + "%",
                    };
                    machines0.push(item);
                }
                //补足剩余部分
                for (; i < MAX_RANK_ITEM; i++) {
                    let item = {
                        key: "m" + (i + 1),
                        name: "",
                        volue: "",
                        percent: "",
                    };
                    machines0.push(item);
                }
                this.machines = machines0;

                // 产能趋势图
                if (response.monthSummary != undefined) {
                    let monthSummary = response.monthSummary; //原始数据在这里
                    let chartData = [];
                    let length =
                        monthSummary.length > MAX_MONTH ? MAX_MONTH : monthSummary.length;
                    for (let i = 0; i < length; i++) {
                        let item = monthSummary[i];
                        
                        // 251030 hcy: 我已经加了productWeight参数，重量，单位g。
                        // let productMeter = item.productMeter / 100000;
                        let productWeight = item.productWeight / 1000;
                        
                        let machineCount = item.machineCount > 0 ? item.machineCount : 1;
                        let effect = (
                            (item.runningTime * 100) /
                            (30 * 86400 * machineCount)
                        ).toFixed(0);
                        let d = [
                            this.utils.timestampToTime(item.whichday).substr(5, 2) + "月",
                            productWeight,
                            effect,
                        ];
                        chartData.unshift(d);
                    }
                    this.monthSummaryChart.dataset.source = chartData;
                    this.bar1.setOption(this.monthSummaryChart);
                }

                //工种统计
                if (response.workerSummary != undefined) {
                    this.$set(
                        this.statuses[0],
                        "volue",
                        String(response.workerSummary.total)
                    );
                    this.$set(
                        this.statuses[1],
                        "volue",
                        String(response.workerSummary.dangche)
                    );
                    this.$set(
                        this.statuses[2],
                        "volue",
                        String(response.workerSummary.jixiu)
                    );
                    this.$set(
                        this.statuses[3],
                        "volue",
                        String(response.workerSummary.pantou)
                    );
                    this.$set(
                        this.statuses[4],
                        "volue",
                        String(response.workerSummary.chuangsha)
                    );
                }

                //右------------------------------------------------
                //实时机台状态
                this.$set(
                    this.machineSummary[0],
                    "volue",
                    String(response.machineSummary.runCount)
                );
                this.$set(
                    this.machineSummary[1],
                    "volue",
                    String(response.machineSummary.pauseCount)
                );
                this.$set(
                    this.machineSummary[2],
                    "volue",
                    String(response.machineSummary.faultCount)
                );
                this.$set(
                    this.machineSummary[3],
                    "volue",
                    String(response.machineSummary.offlineCount)
                );

                //实时工单状态。hcy: 百分比通过productLength/planLength获得.
                for (let i = 0; i < response.machineOrderStatus.length; i++) {
                    // console.log('i=',i)
                    let item = {
                        key: "wo" + (i + 1),
                        number: String(response.machineOrderStatus[i].machineNumber),
                        volue: this.dataChangeToPercent(
                            response.machineOrderStatus[i].productLength,
                            response.machineOrderStatus[i].planLength
                        ),
                    };
                    this.workOrderStatus.push(item);
                }

                // 实时报工记录
                let mhs = response.machineHistories;
                if (mhs != undefined) {
                    for (let i = 0; i < mhs.length; i++) {
                        let mh = mhs[i];
                        let item = {
                            key: "e" + (i + 1),
                            worker: String(mh.worker === null ? "" : mh.worker),
                            machine: String(mh.machineNumber),
                            event: this.productStateChange(mh.productState),
                            time: this.utils.timestampToTime(mh.timepoint),
                        };
                        this.workEvents.push(item);
                    }
                }
            },

            // hcy: 百分比通过productLength/planLength获得.
            dataChangeToPercent(productLength, planLength) {
                if (planLength === 0) {
                    //分母为0直接返回 0%
                    return "0";
                } else {
                    return String(((productLength / planLength) * 100).toFixed(2));
                }
            },

            //实时开机率 = 总开机时间(秒) / 总机台数 * (当前时间sendTime(毫秒)-本日开始时间)
            realtimeRunningEffect(runningTime, machineCount, sendTime) {
                if (machineCount != 0) {
                    if (sendTime == undefined) { //防止异常
                        sendTime = this.utils.getNowTime();
                    }
                    let escape = sendTime - this.utils.getDayStart(sendTime);
                    return (
                        String(
                            ((runningTime * 100000) / (machineCount * escape)).toFixed(2)
                        ) + "%"
                    );
                } else {
                    return "0%";
                }
            },

            //生产状态 变成 文字。
            productStateChange(productState) {
                let result = "";
                switch (productState) {
                    case 0:
                        result = "未运行";
                        break;
                    case 1:
                        result = "异常开机";
                        break;
                    case 2:
                        result = "生产中";
                        break;
                    case 3:
                        result = "生产停机";
                        break;
                    case 4:
                        result = "超时停机";
                        break;
                    case 5:
                        result = "维修停机";
                        break;

                    case 6:
                        result = "维修请求超时";
                        break;
                    case 7:
                        result = "维修中";
                        break;
                    case 8:
                        result = "上盘头请求";
                        break;
                    case 9:
                        result = "上盘头请求超时";
                        break;
                    case 10:
                        result = "上盘头中";
                        break;

                    case 11:
                        result = "穿纱请求";
                        break;
                    case 12:
                        result = "穿纱中";
                        break;
                    case 13:
                        result = "穿纱中";
                        break;
                    case 14:
                        result = "管理员查看";
                        break;
                    case 15:
                        result = "未知人员登录";
                        break;

                    case 16:
                        result = "发现疵点";
                        break;
                    case 17:
                        result = "未配对";
                        break;
                    case 18:
                        result = "维修结束";
                        break;
                    case 19:
                        result = "上盘头结束";
                        break;
                    case 20:
                        result = "穿纱结束";
                        break;

                    case 30:
                        result = "离线中";
                        break;

                    default:
                        break;
                }
                return result;
            },
            resize() {
                this.bar1.setOption(this.monthSummaryChart);
                this.bar1.resize();
            },
        },
        mounted() {
            //产能趋势图
            let bar1 = echarts.init(this.$refs.bar1);
            bar1.setOption(this.monthSummaryChart);
            this.bar1 = bar1;
            this.getData();
            window.addEventListener("resize", this.resize);
        },
    };
</script>

<style lang="scss" scoped>
    body {
        background-color: aquamarine !important;
    }

    .app-main {
        height: 100%;
        background-color: aquamarine !important;
        /* height: 840px !important; */
    }

    .home {
        height: 840px;
        background-color: #00007f;
        color: white;
    }

    .home-block {
        border: 1px solid #fff;
        padding: 10px;

        &.nopad {
            padding: 0;
        }
    }

    .home-block-title {
        font-weight: bold;
        text-align: center;
        margin: 10px 0;
    }

    .home-top-list {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        padding: 10px;

        .home-top-item {
            text-align: center;

            >.home-top-title {
                font-size: 20px;
                font-weight: bold;
            }

            >.home-top-value {
                font-size: 28px;
                margin-top: 5px;
            }
        }
    }

    .home-status-list {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        padding: 10px;

        .home-status-item {
            text-align: center;
            font-weight: bold;
            font-size: 20px;

        }
    }

    .home-summary-grid {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;

        .home-summary-item {
            text-align: center;

            >.home-summary-title {
                font-size: 20px;
                font-weight: bold;
            }

            >.home-summary-value {
                font-size: 28px;
                margin-top: 5px;
            }
        }
    }

    .home-table-title {
        font-weight: bold;
        text-align: center;
        padding: 10px;
    }

    .home-table {
        width: 100%;
        border-collapse: collapse;

        th,
        td {
            text-align: left;
            border: 1px solid #fff;
            padding: 5px;
        }
    }

    .home-order-list {
        min-height: 220px;

        .home-order-item {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            margin: 5px 0;
        }
    }

    .order-progress {
        width: 80%;
        margin-left: 10px;
    }

    .home-work-list {
        min-height: 260px;
    }

    .home-work-event {
        border: 1px solid #ccc;
        padding: 5px;
        margin: 5px;
    }

    .el-divider--horizontal {
        margin: 10px 0;
    }

    .test {
        color: #f56c6c;
        color: #e6a23c;
        color: #5cb87a;
        color: #1989fa;
        color: #6f7ad3;
    }
</style>